import React from 'react';
import {
  string, number, bool, func,
} from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import Popover from '@active/react-ui/Popover';
import Responsive from '@active/react-utils/components/Responsive';
import Currency from '../../../Currency';
import { handleKeyboardEvent } from '../../../../../shared/utils/commonUtils';

const OrderLineField = ({
  title, price, currencyCode, className,
  quantity, isShowButtonCol, isShowEditButton,
  isShowDelButton,
  handleOrderReviewCallback,
  identifier: checkoutOrderLineIdentifier,
  checkoutOrderIdentifier, pendingLine,
  justLabel,
  trackingCallback,
  labelSpanConfig, valueSpanConfig, btnColSpanConfig,
}) => {
  if (!title) {
    return null;
  }
  const handleButtonClicked = type => () => {
    trackingCallback && trackingCallback({ id: `cui.${type}Link.clicked` });
    handleOrderReviewCallback({
      type,
      checkoutOrderLineIdentifier,
      checkoutOrderIdentifier,
    });
  };

  const DeleteBtn = React.forwardRef((props, ref) => {
    return <i className="ic-trash-can link-style"
      {...props}
      ref={ref}
      tabIndex="0"
      role="button"
      aria-label='delete-button'
      onKeyDown={handleKeyboardEvent(handleButtonClicked('delete'), [ 'Enter' ])}
      onClick={handleButtonClicked('delete')} />;
  });

  const EditBtn = React.forwardRef((props, ref) => {
    return <i className="ic-edit link-style"
      {...props}
      ref={ref}
      tabIndex="0"
      role="button"
      aria-label='edit-button'
      onKeyDown={handleKeyboardEvent(handleButtonClicked('edit'), [ 'Enter' ])}
      onClick={handleButtonClicked('edit')}/>;
  });

  const orderlineClasses = classnames({
    'orderline-field__value': true,
    'red-amount': price < 0,
    'button-exsist': isShowButtonCol,
  });

  const gridClasses = classnames('orderline-field', className);

  return <Grid fluid={true} container={false} rowGap={0} colGap={16} align={'start'} justify={'start'}
    className={gridClasses}>
    <GridItem {...labelSpanConfig} className="orderline-field__label">
      {
        title
      }
    </GridItem>
    {justLabel ? null
      : <React.Fragment>
        <GridItem
          {...valueSpanConfig}
          className={orderlineClasses}>
          {
            quantity > 1 && <span className="orderline-field__quantity">
              {quantity}
              &nbsp;&times;
            </span>
          }
          <span className="orderline-field__amount"><Currency amount={price} code={currencyCode} /></span>
          {
            pendingLine && <div className="orderline-field__pending"><Locale id="checkout.lib.components.text.pending"/></div>
          }
        </GridItem>
        {isShowButtonCol
        && <GridItem {...btnColSpanConfig} className="orderline-field__buttons">
          { isShowEditButton
            && <React.Fragment>
              <Responsive not eqAbove="xl">
                <EditBtn/>
              </Responsive>
              <Responsive eqAbove="xl">
                <Popover placement={'top'}
                  style={{ zIndex: 9999 }}
                  theme="dark"
                  content={<div>
                    <Locale id="checkout.lib.components.common.btn.edit" />
                  </div>}>
                  <EditBtn/>
                </Popover>
              </Responsive>
            </React.Fragment>}
          { isShowDelButton
            && <React.Fragment>
              <Responsive not eqAbove="xl">
                <DeleteBtn/>
              </Responsive>
              <Responsive eqAbove="xl">
                <Popover placement={'top'}
                  style={{ zIndex: 9999 }}
                  theme="dark"
                  content={<div>
                    <Locale id="checkout.lib.components.common.btn.delete" />
                  </div>}>
                  <DeleteBtn/>
                </Popover>
              </Responsive>
            </React.Fragment>}
        </GridItem>
        }
      </React.Fragment>
    }
  </Grid>;
};

OrderLineField.propTypes = {
  title: string,
  price: number,
  currencyCode: string,
  className: string,
  quantity: number,
  isShowButtonCol: bool,
  isShowEditButton: bool,
  isShowDelButton: bool,
  pendingLine: bool,
  handleOrderReviewCallback: func,
  trackingCallback: func,
};

OrderLineField.defaultProps = {
  isShowButtonCol: false,
  isShowEditButton: false,
  isShowDelButton: false,
  justLabel: false,
  pendingLine: false,
  handleOrderReviewCallback: noop,
};

export default OrderLineField;
